module.exports = __webpack_public_path__ + "static/D_Implant-22d9c63bcf71be6ff9fbe132496cebde.jpg";